import axios from "axios";
import { Action, ActionType } from "../actions";
import { Dispatch } from "redux";
import { API } from "../../utils/apis";

export const searchRepositories = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SEARCH_REPOSITORIES,
    });

    try {
      const { data } = await axios.get(
        API.publicVideos
        // {
        //   params: {
        //     text: queryString,
        //   },
        // }
      );
      const videosData = data.videos;
      console.log("videosData", videosData);
      dispatch({
        type: ActionType.SEARCH_REPOSITORIES_SUCCESS,
        payload: videosData,
      });
    } catch (err: any) {
      dispatch({
        type: ActionType.SEARCH_REPOSITORIES_ERROR,
        payload: "err.message",
      });
    }
  };
};
